import React from 'react';
import Error from '../../pages/Error';

const UnknownError = (props: { clearError?: () => void; }): React.JSX.Element => {
    const unknownErrorMessages = [
        'Oh no!',
        "This isn't how this is supposed to work!",
        "We're just as confused as you...",
        'An Unexpected Error Occurred',
    ];
    const reason = "Whoops! Looks like something went wrong. We're sorry for any inconvenience to you.";

    return <Error messages={unknownErrorMessages} defaultReason={reason} onNavigation={props.clearError} />;
};

export default UnknownError;
